/* Altersklassen (U17, U19) — reine Funktionen, kein DOM.
 *
 * EINE Quelle für Profil-Chip, Auswahlfeld in "Edit details", Listenfilter, Mehrfachzuordnung, Export und Tests.
 * Gespeichert wird der Schlüssel `ageGroup` im Datenblock players.data: "U17", "U19" oder leer/nicht gesetzt.
 * Keine automatische Zuordnung nach Geburtsjahr — die Klasse wird von Hand gesetzt (Entscheidung Bastian).
 * Ein unbekannter Wert (Altlast, Tippfehler) gilt wie "keine Altersklasse" und wird nie angezeigt.
 *
 * Staff liest die Klasse über die Ansicht players_staff (Positivliste, supabase/migrations/…_staff_altersklasse.sql).
 * Fehlt der Schlüssel dort noch, ist er schlicht leer — die App läuft vor und nach dem SQL.
 */

/** Erlaubte Werte; die Beschriftung ist der Wert selbst (nicht übersetzt, wie die Positionskürzel). */
export const AGE_GROUPS = ['U17', 'U19'];

/** Filterwert "alle" (dieselbe Schreibweise wie squadFilter.ALL). */
export const AGE_GROUP_ALL = 'all';

/** Ist das ein gültiger Wert? */
export function isAgeGroup(v) {
  return AGE_GROUPS.includes(v);
}

/** Wert bereinigen: gültiger Wert bleibt, alles andere wird '' (keine Altersklasse). */
export function normalizeAgeGroup(v) {
  return isAgeGroup(v) ? v : '';
}

/** Altersklasse eines Spielers ('' = keine). */
export function ageGroupOf(player) {
  return normalizeAgeGroup(player && player.ageGroup);
}

/** Beschriftung eines Werts (der Wert selbst); '' für keine. */
export function ageGroupLabel(v) {
  return normalizeAgeGroup(v);
}

/**
 * Datenblock mit gesetzter Altersklasse (für die Mehrfachzuordnung, die den frischen Datenblock aus der Datenbank
 * bearbeitet, nicht das Spielerobjekt). Gültiger Wert: setzen. Leer/ungültig ("None"): Schlüssel entfernen.
 * Alle anderen Schlüssel bleiben unangetastet; die Eingabe wird nicht verändert.
 */
export function withAgeGroup(data, value) {
  const next = { ...(data && typeof data === 'object' ? data : {}) };
  const v = normalizeAgeGroup(value);
  if (v) next.ageGroup = v;
  else delete next.ageGroup;
  return next;
}

/**
 * Zeigt eine Liste den Filter nach Altersklasse? Wer die Klasse pflegen darf, immer; alle anderen (staff, Gäste) nur, wenn
 * wenigstens ein Spieler der Liste eine hat. Fehlt Gästen die Spalte age_group (SQL noch nicht ausgeführt), hat keiner
 * eine — der Filter bleibt dann weg, sonst nichts. Die Rolle spielt keine weitere Rolle (F16).
 */
export function showAgeGroupFilter(canWrite, anyAgeGroup) {
  return !!canWrite || !!anyAgeGroup;
}

/** Anzahl je Wert für die Filterknöpfe: { all, U17, U19 }. */
export function ageGroupCounts(players) {
  const list = players || [];
  const counts = { [AGE_GROUP_ALL]: list.length };
  for (const g of AGE_GROUPS) counts[g] = 0;
  for (const p of list) {
    const g = ageGroupOf(p);
    if (g) counts[g] += 1;
  }
  return counts;
}
